import API_BASE_URL from "../../config/api";
export async function fetchLoggedInUser(userName) {
  const response = await fetch(
    `${API_BASE_URL}/api/employee/getbyusername/${userName}`,
    {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
    }
  );
  const data = await response.json();
  sessionStorage.setItem("employeeId", data.id);
  return data;
}
